import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {EmptyStatePopover} from 'shells/empty-states/empty-state-popover';
import {Link} from 'shells/link/link';

import type {EmailStats as EmailStatsFragment} from 'nutshell-graphql-types';

import styles from './email-health-root.module.css';

type Props = {
    emailStats: EmailStatsFragment | null | undefined;
    handlePopoverBlur: () => void;
};

export function EmailStatusEmptyState(props: Props) {
    if (!props.emailStats) return null;

    return (
        <div className={styles['empty-state-container']}>
            <EmptyStatePopover
                title='All your email in one place'
                subtitle='Send, schedule, and read email, all within Nutshell'
                cta={
                    <Link
                        variant='button-primary'
                        size='big'
                        // @ts-expect-error
                        as={RoutedLink}
                        onClick={props.handlePopoverBlur}
                        to={{hash: '/connect-email/get-started'}}
                    >
                        Connect your email
                    </Link>
                }
            />
        </div>
    );
}
